import type { Column } from "@tanstack/react-table";
import type { CSSProperties } from "react";

export const getPinningStyles = <T>(
  column: Column<T>,
  isHeader = false,
): CSSProperties => {
  const isPinned = column.getIsPinned();

  return {
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column.getAfter("right")}px` : undefined,
    position: isPinned ? "sticky" : "relative",
    width: column.getSize(),
    zIndex: isPinned ? (isHeader ? 3 : 2) : 1,
    margin: 0,
    isolation: isPinned ? "isolate" : undefined,
  };
};
